module.exports = __webpack_public_path__ + "img/pdf-icon-circle.a8d42c91.svg";